import {useId} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {SlotSlider} from "@pg-design/slot-slider-module";
import {Text} from "@pg-design/text-module";

import {usePersonalizedHomepageImpression} from "../../hooks/use_personalized_homepage_impression";
import {IPersonalizedPropertyCard} from "../../types/IPersonalizedHomepage";
import {PersonalizedHomepageRecentlyViewedTile} from "./PersonalizedHomepageRecentlyViewedTile";

interface IProps {
    properties: IPersonalizedPropertyCard[];
    isLoading?: boolean;
    hasError?: boolean;
    emptyStateHref: string;
    onView?: (items: {property: IPersonalizedPropertyCard; index: number}[]) => void;
    onPropertyClick?: (property: IPersonalizedPropertyCard, index: number) => void;
}

const RECENTLY_VIEWED_SKELETON_TILES = [0, 1, 2, 3];

export const PersonalizedHomepageRecentlyViewedCard = (props: IProps) => {
    const {properties, isLoading = false, hasError = false, emptyStateHref, onView, onPropertyClick} = props;
    const headingId = useId();
    const isEmpty = !isLoading && (hasError || properties.length === 0);
    const sectionRef = usePersonalizedHomepageImpression<HTMLElement>({
        isEnabled: !isLoading && !isEmpty && !!onView,
        onImpression: () => {
            // SlotSlider renders the track as the section's only list, one item per property.
            const carousel = sectionRef.current?.querySelector<HTMLUListElement>('[role="list"]');

            if (!carousel) {
                return;
            }

            const bounds = carousel.getBoundingClientRect();
            const visibleLeft = Math.max(bounds.left, 0);
            const visibleRight = Math.min(bounds.right, window.innerWidth);
            const visibleItems = Array.from(carousel.children).flatMap((tile, index) => {
                const tileBounds = tile.getBoundingClientRect();
                const visibleWidth = Math.min(tileBounds.right, visibleRight) - Math.max(tileBounds.left, visibleLeft);
                const property = properties[index];

                // Count the offer only when at least half of its tile is visible in the carousel.
                return property && tileBounds.width > 0 && visibleWidth >= tileBounds.width / 2 ? [{property, index}] : [];
            });

            if (visibleItems.length > 0) {
                onView?.(visibleItems);
            }
        }
    });

    const heading = (
        <Text id={headingId} as="h2" variant="headline_6" className={headingStyle}>
            Ostatnio oglądane oferty
        </Text>
    );

    return (
        <section className={cardStyle} ref={sectionRef} aria-labelledby={headingId} aria-busy={isLoading}>
            {isEmpty ? (
                <>
                    {heading}

                    <div className={emptyStateStyle} role="status">
                        <Text as="p" variant="body_copy_2" className={emptyStateTextStyle}>
                            {hasError
                                ? "Nie udało się wczytać ostatnio oglądanych ofert."
                                : "Mieszkania, które obejrzysz, pojawią się tutaj — wrócisz do nich jednym kliknięciem."}
                        </Text>
                        <Button variant="outlined_secondary" size="small" href={emptyStateHref}>
                            Przejdź do ofert
                        </Button>
                    </div>
                </>
            ) : (
                <SlotSlider
                    className={sliderStyle}
                    header={heading}
                    navigationClassName={navigationStyle}
                    arrowClassName={arrowStyle}
                    listClassName={listStyle}
                    itemClassName={itemStyle}
                    listLabel="Ostatnio oglądane oferty"
                    prevLabel="Poprzednie oferty"
                    nextLabel="Następne oferty"
                >
                    {isLoading
                        ? RECENTLY_VIEWED_SKELETON_TILES.map((tile) => <span key={tile} className={skeletonTileStyle} />)
                        : properties.map((property, index) => (
                              <PersonalizedHomepageRecentlyViewedTile key={property.id} property={property} index={index} onPropertyClick={onPropertyClick} />
                          ))}
                </SlotSlider>
            )}
        </section>
    );
};

const cardStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    boxSizing: "border-box",
    padding: 2,
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,

    md: {
        padding: 3
    }
});

const headingStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});

const sliderStyle = css({
    "--slot-slider-arrow-size": "3.2rem"
});

const navigationStyle = css({
    gap: 1
});

const arrowStyle = css({
    backgroundColor: "var(--colors-primary)",
    border: "none",

    // Touch screens keep :hover active after a tap — the pressed arrow would stay dark until the next tap elsewhere.
    "@media (hover: hover)": {
        '&:not([aria-disabled="true"]):hover': {
            backgroundColor: "var(--colors-secondary)",
            color: "var(--colors-white)"
        }
    }
});

const listStyle = css({
    gap: 3,

    md: {
        gap: 1
    }
});

/** Full tile on narrow screens — the fixed 34.1rem must not overflow the card. */
const itemStyle = css({
    width: "min(34.1rem, 100%)"
});

const skeletonTileStyle = css({
    display: "block",
    width: "100%",
    height: "44.2rem",
    backgroundColor: "var(--colors-gray-200)",
    borderRadius: 2,

    md: {
        height: "41rem"
    }
});

const emptyStateStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 2,
    py: 3
});

const emptyStateTextStyle = css({
    margin: 0,
    color: "var(--colors-gray-700)"
});
import {useId} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {SlotSlider} from "@pg-design/slot-slider-module";
import {Text} from "@pg-design/text-module";

import {usePersonalizedHomepageImpression} from "../../hooks/use_personalized_homepage_impression";
import {IPersonalizedPropertyCard} from "../../types/IPersonalizedHomepage";
import {PersonalizedHomepageRecentlyViewedTile} from "./PersonalizedHomepageRecentlyViewedTile";

interface IProps {
    properties: IPersonalizedPropertyCard[];
    isLoading?: boolean;
    hasError?: boolean;
    emptyStateHref: string;
    onView?: (items: {property: IPersonalizedPropertyCard; index: number}[]) => void;
    onPropertyClick?: (property: IPersonalizedPropertyCard, index: number) => void;
}

const RECENTLY_VIEWED_SKELETON_TILES = [0, 1, 2, 3];

export const PersonalizedHomepageRecentlyViewedCard = (props: IProps) => {
    const {properties, isLoading = false, hasError = false, emptyStateHref, onView, onPropertyClick} = props;
    const headingId = useId();
    const isEmpty = !isLoading && (hasError || properties.length === 0);
    const sectionRef = usePersonalizedHomepageImpression<HTMLElement>({
        isEnabled: !isLoading && !isEmpty && !!onView,
        onImpression: () => {
            // SlotSlider renders the track as the section's only list, one item per property.
            const carousel = sectionRef.current?.querySelector<HTMLUListElement>('[role="list"]');

            if (!carousel) {
                return;
            }

            const bounds = carousel.getBoundingClientRect();
            const visibleLeft = Math.max(bounds.left, 0);
            const visibleRight = Math.min(bounds.right, window.innerWidth);
            const visibleItems = Array.from(carousel.children).flatMap((tile, index) => {
                const tileBounds = tile.getBoundingClientRect();
                const visibleWidth = Math.min(tileBounds.right, visibleRight) - Math.max(tileBounds.left, visibleLeft);
                const property = properties[index];

                // Count the offer only when at least half of its tile is visible in the carousel.
                return property && tileBounds.width > 0 && visibleWidth >= tileBounds.width / 2 ? [{property, index}] : [];
            });

            if (visibleItems.length > 0) {
                onView?.(visibleItems);
            }
        }
    });

    const heading = (
        <Text id={headingId} as="h2" variant="headline_6" className={headingStyle}>
            Ostatnio oglądane oferty
        </Text>
    );

    return (
        <section className={cardStyle} ref={sectionRef} aria-labelledby={headingId} aria-busy={isLoading}>
            {isEmpty ? (
                <>
                    {heading}

                    <div className={emptyStateStyle} role="status">
                        <Text as="p" variant="body_copy_2" className={emptyStateTextStyle}>
                            {hasError
                                ? "Nie udało się wczytać ostatnio oglądanych ofert."
                                : "Mieszkania, które obejrzysz, pojawią się tutaj — wrócisz do nich jednym kliknięciem."}
                        </Text>
                        <Button variant="outlined_secondary" size="small" href={emptyStateHref}>
                            Przejdź do ofert
                        </Button>
                    </div>
                </>
            ) : (
                <SlotSlider
                    className={sliderStyle}
                    header={heading}
                    navigationClassName={navigationStyle}
                    arrowClassName={arrowStyle}
                    listClassName={listStyle}
                    itemClassName={itemStyle}
                    listLabel="Ostatnio oglądane oferty"
                    prevLabel="Poprzednie oferty"
                    nextLabel="Następne oferty"
                >
                    {isLoading
                        ? RECENTLY_VIEWED_SKELETON_TILES.map((tile) => <span key={tile} className={skeletonTileStyle} />)
                        : properties.map((property, index) => (
                              <PersonalizedHomepageRecentlyViewedTile key={property.id} property={property} index={index} onPropertyClick={onPropertyClick} />
                          ))}
                </SlotSlider>
            )}
        </section>
    );
};

const cardStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    boxSizing: "border-box",
    padding: 2,
    backgroundColor: "var(--colors-white)",
    borderRadius: 2,

    md: {
        padding: 3
    }
});

const headingStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});

const sliderStyle = css({
    "--slot-slider-arrow-size": "3.2rem"
});

const navigationStyle = css({
    gap: 1
});

const arrowStyle = css({
    backgroundColor: "var(--colors-primary)",
    border: "none",

    // Touch screens keep :hover active after a tap — the pressed arrow would stay dark until the next tap elsewhere.
    "@media (hover: hover)": {
        '&:not([aria-disabled="true"]):hover': {
            backgroundColor: "var(--colors-secondary)",
            color: "var(--colors-white)"
        }
    }
});

const listStyle = css({
    gap: 3,

    md: {
        gap: 1
    }
});

/** Full tile on narrow screens — the fixed 34.1rem must not overflow the card. */
const itemStyle = css({
    width: "min(34.1rem, 100%)"
});

const skeletonTileStyle = css({
    display: "block",
    width: "100%",
    height: "44.2rem",
    backgroundColor: "var(--colors-gray-200)",
    borderRadius: 2,

    md: {
        height: "41rem"
    }
});

const emptyStateStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 2,
    py: 3
});

const emptyStateTextStyle = css({
    margin: 0,
    color: "var(--colors-gray-700)"
});
